import React from 'react';
import Loadable from 'react-loadable';

import LoadingState from '@swf/sports/components/LoadingState/LoadingState';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsEventInfoWidget" */ './SportsEventInfoWidget'),
  modules: ['./SportsEventInfoWidget'],
  loading: () => <LoadingState />
});

export default LoadableWidget;
